import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Checkbox } from '@dls/web';

import { enableNetwork, disableNetwork, selectNetwork } from './networkSlice';

const StyledNetwork = styled.div``;

export const Network = () => {
  const dispatch = useDispatch();
  const network = useSelector(selectNetwork);

  return (
    <StyledNetwork>
      <Checkbox.Input
        label="Click me"
        id="checkbox-id"
        checked={network}
        onChange={(e: any, checked: boolean) => {
          checked ? dispatch(enableNetwork()) : dispatch(disableNetwork());
        }}
      />
    </StyledNetwork>
  );
};
